import * as Api from '@ViewModels';

export { toActionItemContent } from '../../../../models/utils/actionItemContent';

function splitLines(item: Pick<Api.IActionItem, 'plainTextContent' | 'preview'>): string[] {
	const text = item.plainTextContent?.trim() || item.preview?.trim() || '';
	return text
		.split(/\r?\n/)
		.map(line => line.trim())
		.filter(Boolean);
}

export function getActionItemTitle(item: Pick<Api.IActionItem, 'plainTextContent' | 'preview'>): string {
	return splitLines(item)[0] ?? 'Action item';
}

export function getActionItemSecondaryText(item: Pick<Api.IActionItem, 'plainTextContent' | 'preview'>): string {
	return splitLines(item).slice(1).join(' ');
}

export function getActionItemParagraphs(item: Pick<Api.IActionItem, 'plainTextContent' | 'preview'>): string[] {
	return splitLines(item);
}
